import React from 'react';
import { Link } from 'gatsby';

import '../../styles/common/page-title.scss';

export default React.forwardRef((props, ref) => (
  <h1
    ref={ref}
    className="page-title"
  >
    <div className="title">
      <span className={`label ${props.titleCase ? 'title-case' : ''}`}>
        {(props.to) ? (
          <Link to={props.to}>{props.title}</Link>
        ) : props.title}
      </span>
    </div>
    {props.subtitle ? (
      <span className="subtitle">{props.subtitle}</span>
    ) : null}
  </h1>
));